import * as types from '../actions/types'
import Immutable from 'immutable'
import diff from 'immutablediff'
import patch from 'immutablepatch'


import {
    isPrimitive,
    adjunto
} from '../utils/helpers'


const INITIAL_STATE = Immutable.fromJS({
    id: null,
    estado: 0,
	solicitud: {},
    btnSaveDisabled: true,
    btnRComprasDisabled: true,
    modified: [],
    modalCreateDocumento: {
		title: '',
		show: false,
		data: null,
		btnDisabled: false,
		unchanged: null,
		plantillas: []
    },

    modalAddFirmas: {
        show: false,
        data: null
    },


})

export default function (state = INITIAL_STATE, action) {

	switch (action.type) {

        case types.REINICIAR_SOLICITUD_CONTRATOANUAL1:
			return INITIAL_STATE
			
		case types.ADICIONAR_MODIFICACION_SOLICITUD_CONTRATOANUAL:
            state = state.set('modified', state.get('modified').filter(x => x.get('entity') + x.get('attribute') + x.get('id') !== action.payload.entity + action.payload.attribute + action.payload.id))
            state = state.update('modified', list => list.push(Immutable.fromJS(action.payload)))
            state = state.set('btnSaveDisabled', state.get('modified').count() === 0)
			return state
			

        case types.OBTENER_SOLICITUD_CONTRATOANUAL:
			state = state.set('id', action.payload.solicitud.id)
			state = state.set('estado', action.payload.solicitud.estado)
			state = state.set('solicitud', Immutable.fromJS(action.payload.solicitud))
            if (action.payload.reset !== false) {
                state = state.set('modified', INITIAL_STATE.get('modified'))
            }
            state = state.set('btnSaveDisabled', state.get('modified').count() === 0)
			return state


		// case types.ACTUALIZAR_SOLICITUD_CONTRATOANUAL:
        //     const ops = diff(state.get('solicitud'), Immutable.fromJS(action.payload))
        //     state = state.set('solicitud', patch(state.get('solicitud'), ops))
        //     if (ops.filter(x => x.get('path') === '/estado').count() === 1) {
        //         state = state.set('estado', state.getIn(['solicitud', 'estado']))
        //     }
        //     state = state.set('btnRComprasDisabled', true)
        //     return state


		case types.ACTUALIZAR_SOLICITUD_CONTRATOANUAL:
            const ops = diff(state.get('solicitud'), Immutable.fromJS(action.payload.solicitud))
            state = state.set('solicitud', patch(state.get('solicitud'), ops))
            if (ops.filter(x => x.get('path') === '/estado').count() === 1) {
                state = state.set('estado', state.getIn(['solicitud', 'estado']))
            }
            state = state.set('btnRComprasDisabled', true)
            return state
			

		case types.MOSTRAR_MODAL_CREAR_DOCUMENTO_SOLICITUD_CONTRATOANUAL:

            state = state.setIn(['modalCreateDocumento', 'show'], action.payload.show)

            if (action.payload.show) { 

                state = state.setIn(['modalCreateDocumento', 'title'], action.payload.title)
				state = state.setIn(['modalCreateDocumento', 'plantillas'], Immutable.fromJS(action.payload.plantillas))
				state = state.setIn(['modalCreateDocumento', 'data'], state.getIn(['solicitud', 'documentos', action.payload.indexDocumento]))
				state = state.setIn(['modalCreateDocumento', 'unchanged'], state.getIn(['solicitud', 'documentos', action.payload.indexDocumento]))

            } else {
                state = state.set('modalCreateDocumento', INITIAL_STATE.get('modalCreateDocumento'))
            }
            
			return state


		case types.MODIFICAR_INPUTS_SOLICITUD_CONTRATOANUAL1:
            if (isPrimitive(action.payload.value)) {
    			state = state.setIn(`${action.payload.path}`.split('.'), action.payload.value)
            } else {
                if (action.payload.immutable === false) {
                    state = state.setIn(`${action.payload.path}`.split('.'), action.payload.value)
                } else {
                    state = state.setIn(`${action.payload.path}`.split('.'), Immutable.fromJS(action.payload.value))
                }
            }
            if (action.payload.path.split('.').slice(-1)[0] == 'responsable_compras') {
                state = state.set('btnRComprasDisabled', false)
            }
            return state



        case types.MOSTRAR_MODAL_ADICION_FIRMAS:           

            if (action.payload.show) {

                //const documentos = state.getIn(['solicitud', 'documentos']).filter(x => x.get('tipo') == 5 && x.get('documento_id') == null && x.get('estado') > 0 && x.get('estado') < 11)
                //const documentos = action.payload.documentos.filter(x => x.get('tipo') == 5 && x.get('documento_id') == null && x.get('estado') > 0 && x.get('estado') < 11)

                const documentos = action.payload.solicitud.get('documentos').filter(x => x.get('tipo') == 5 && x.get('documento_id') == null && x.get('estado') > 0 && x.get('estado') < 11)
                const documento_id = documentos.count() > 0 ? documentos.first().get('id') : null

                state = state.setIn(['modalAddFirmas', 'show'], true)                
                state = state.setIn(['modalAddFirmas', 'data'], Immutable.fromJS(adjunto()))
                state = state.setIn(['modalAddFirmas', 'data', 'documento_id'], documento_id)
                state = state.setIn(['modalAddFirmas', 'data', 'clasificacion'], 'CONTRATO FIRMADO')
                state = state.setIn(['modalAddFirmas', 'data', 'observaciones'], 'Contrato firmado y aceptado por el proveedor')
                state = state.setIn(['modalAddFirmas', 'data', 'editable'], 0)

            } else {
                state = state.set('modalAddFirmas', INITIAL_STATE.get('modalAddFirmas'))
            }
            return state

        case types.DESHABILITAR_BOTON_GUARDAR_CREACION_CONTRATO:
            return state.setIn(['modalCreateDocumento', 'btnDisabled'], action.payload)

       	default:
            return state

	}
}



// WEBPACK FOOTER //
// ./src/reducers/contratoanual.js